import { render, staticRenderFns } from "./Logauth.vue?vue&type=template&id=b28cc454"
import script from "./Logauth.vue?vue&type=script&lang=js"
export * from "./Logauth.vue?vue&type=script&lang=js"
import style0 from "./Logauth.vue?vue&type=style&index=0&id=b28cc454&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports